<template>
  <div>
    <v-hover v-slot="{ hover }" :disabled="disabled">
      <v-card
        height="175"
        width="175"
        :class="[
          'rounded-10',
          'blue-border',
          { 'btn-primary': hover, 'disabled-button': disabled }
        ]"
        v-ripple
        @click="$emit('chooseOrder', 'FINISHED')"
      >
        <v-card-text
          class="px-1 text-center text-subtitle-1 pb-0"
          :style="{
            color: hover ? 'white' : '#147BD1'
          }"
        >
          <strong> FINISHED PROSTHESIS </strong>
        </v-card-text>
        <v-container fluid>
          <v-img
            contain
            :src="require('@/assets/final-prosthesis-bar-retained.png')"
            position="center center"
          ></v-img>
        </v-container>
      </v-card>
    </v-hover>
    <v-card flat max-width="275px">
      <v-card-actions class="pb-0">
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="ml-2"
              elevation="0"
              fab
              x-small
              @click="collapsed = !collapsed"
            >
              <v-icon>
                {{ collapsed ? "mdi-information-outline" : "mdi-chevron-up" }}
              </v-icon>
            </v-btn>
          </template>
          <span>Click for further info</span>
        </v-tooltip>
        <v-spacer />
      </v-card-actions>
      <v-card-text class="text-left pa-2">
        <ul>
          <li class="font-weight-bold">
            Fully finished Nexus Hybrid prosthesis.
          </li>
          <li>Ready for patient insert.</li>
          <li>Includes all screws.</li>
          <li>Requires necessary scans and photos.</li>
        </ul>
      </v-card-text>
      <v-expand-transition>
        <v-card-text class="py-2 mx-2 text-left" v-if="!collapsed">
          <v-divider class="py-1" />
          Finished prosthesis orders are for fully-finished Nexus prosthetics.
          Choose between PMMA or Monolithically Layered Zirconia. Orders will be
          redirected to the Nexus iOS ordering platform to cover all relevant
          clinical questions.
          <br />
          <a
            href="https://nexusconnectlab.zendesk.com/hc/en-us/articles/12679825008527-Finished-Case-Order"
            target="_blank"
            >Find out more via the Knowledge Base.</a
          >
        </v-card-text>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "FinishedProsthesisButton",

  props: ["disabled"],

  data() {
    return {
      collapsed: true
    }
  }
}
</script>

<style scoped>
.disabled-button {
  cursor: not-allowed;
  pointer-events: none;
  filter: grayscale(10%) brightness(80%);
  opacity: 0.5;
}
</style>
